"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var NotificationModel = /** @class */ (function () {
    function NotificationModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/notifications",
            UPDATE: APPURL + "/api/v1/notifications",
            CREATE: APPURL + "/api/v1/notifications",
        };
        this.notifications = [];
        this.cacheResults = this.cacheResults.bind(this);
        this.extract = this.extract.bind(this);
        this.getNotifications = this.getNotifications.bind(this);
    }
    NotificationModel.prototype.extract = function (result) {
        return result.data;
    };
    NotificationModel.prototype.cacheResults = function (result) {
        this.notifications = this.extract(result);
        return this.notifications;
    };
    NotificationModel.prototype.getNotifications = function (data) {
        if (data) {
            return this.$http
                .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    return NotificationModel;
}());
NotificationModel.$inject = ["$http", "APPURL"];
exports.default = NotificationModel;
